export const internokironInitialValues = {
  id: '',
  anagrafica: '', // Id anagrafica collegata
  profili: [], // Array di ID
};

export const mapToInternokironInitialValues = (newValues) => {
  const mappedValues = {
    id: newValues.id || '',
    anagrafica: newValues.anagrafica || '', // Id anagrafica collegata
    profili:  newValues._embedded.profili ? newValues._embedded.profili.map((profilo) => ({ // eslint-disable-line
      value: profilo.id,
      label: profilo.nome,
      key: profilo.id,
    })) : [],
  };

  return mappedValues;
};

export default internokironInitialValues;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/InternoKiron/initialValues.js